export const DUMMY_DEVICES = {
    'dev_id_a': {
        'sensor_a1': {
            'config_a1': {
                'param_a1': {
                    'subparam_a11': 'number',
                    'subparam_a12': 'number',
                    'subparam_a13': 'boolean',
                    'subparam_a14': 'number',
                    'subparam_a15': 'text'
                },
                'param_a2': {
                    'subparam_a21': 'number',
                    'subparam_a22': 'number',
                    'subparam_a23': 'boolean',
                    'subparam_a24': 'number',
                    'subparam_a25': 'text'
                },
                'param_a3': {
                    'subparam_a31': 'number',
                    'subparam_a32': 'number',
                    'subparam_a33': 'boolean',
                    'subparam_a34': 'number',
                    'subparam_a35': 'text'
                },
                'param_a13': 'textssss'
            },
            'config_a2': {
                'param_a4': {
                    'subparam_a41': 'number',
                    'subparam_a42': 'number',
                    'subparam_a43': 'boolean',
                    'subparam_a44': 'number',
                    'subparam_a45': 'text'
                },
                'param_a5': {
                    'subparam_a51': 'number',
                    'subparam_a52': 'number',
                    'subparam_a53': 'boolean',
                    'subparam_a54': 'number',
                    'subparam_a55': 'text'
                }
            }
        },
        'sensor_a2': {
            'config_a3': {
                'param_a1': {
                    'subparam_a11': 'number',
                    'subparam_a12': 'number',
                    'subparam_a13': 'boolean',
                    'subparam_a14': 'number',
                    'subparam_a15': 'text'
                },
                'param_a2': {
                    'subparam_a21': 'number',
                    'subparam_a22': 'number',
                    'subparam_a23': 'boolean',
                    'subparam_a24': 'number',
                    'subparam_a25': 'text'
                },
                'param_a3': {
                    'subparam_a31': 'number',
                    'subparam_a32': 'number',
                    'subparam_a33': 'boolean',
                    'subparam_a34': 'number',
                    'subparam_a35': 'text'
                }
            },
            'config_a4': {
                'param_a4': {
                    'subparam_a41': 'number',
                    'subparam_a42': 'number',
                    'subparam_a43': 'boolean',
                    'subparam_a44': 'number',
                    'subparam_a45': 'text'
                },
                'param_a5': {
                    'subparam_a51': 'number',
                    'subparam_a52': 'number',
                    'subparam_a53': 'boolean',
                    'subparam_a54': 'number',
                    'subparam_a55': 'text'
                }
            }
        }
    },

    'dev_id_b': {
        'sensor_b1': {
            'config_b1': {
                'param_b1': {
                    'subparam_b11': 'number',
                    'subparam_b12': 'number',
                    'subparam_b13': 'boolean',
                    'subparam_b14': 'number',
                    'subparam_b15': 'text'
                },
                'param_b2': {
                    'subparam_b21': 'number',
                    'subparam_b22': 'number',
                    'subparam_b23': 'boolean',
                    'subparam_b24': 'number',
                    'subparam_b25': 'text'
                },
                'param_b3': {
                    'subparam_b31': 'number',
                    'subparam_b32': 'number',
                    'subparam_b33': 'boolean',
                    'subparam_b34': 'number',
                    'subparam_b35': 'text'
                }
            },
            'config_b2': {
                'param_b4': {
                    'subparam_b41': 'number',
                    'subparam_b42': 'number',
                    'subparam_b43': 'boolean',
                    'subparam_b44': 'number',
                    'subparam_b45': 'text'
                },
                'param_b5': {
                    'subparam_b51': 'number',
                    'subparam_b52': 'number',
                    'subparam_b53': 'boolean',
                    'subparam_b54': 'number',
                    'subparam_b55': 'text'
                }
            }
        },
        'sensor_b2': {
            'config_b3': {
                'param_b1': {
                    'subparam_b11': 'number',
                    'subparam_b12': 'number',
                    'subparam_b13': 'boolean',
                    'subparam_b14': 'number',
                    'subparam_b15': 'text'
                },
                'param_b2': {
                    'subparam_b21': 'number',
                    'subparam_b22': 'number',
                    'subparam_b23': 'boolean',
                    'subparam_b24': 'number',
                    'subparam_b25': 'text'
                },
                'param_b3': {
                    'subparam_b31': 'number',
                    'subparam_b32': 'number',
                    'subparam_b33': 'boolean',
                    'subparam_b34': 'number',
                    'subparam_b35': 'text'
                }
            },
            'config_b4': {
                'param_b4': {
                    'subparam_b41': 'number',
                    'subparam_b42': 'number',
                    'subparam_b43': 'boolean',
                    'subparam_b44': 'number',
                    'subparam_b45': 'text'
                },
                'param_b5': {
                    'subparam_b51': 'number',
                    'subparam_b52': 'number',
                    'subparam_b53': 'boolean',
                    'subparam_b54': 'number',
                    'subparam_b55': 'text'
                }
            }
        }
    },

    'dev_id_c': {
        'sensor_c1': {
            'config_c1': {
                'param_c1': {
                    'subparam_c11': 'number',
                    'subparam_c12': 'number',
                    'subparam_c13': 'boolean',
                    'subparam_c14': 'number',
                    'subparam_c15': 'text'
                },
                'param_c2': {
                    'subparam_c21': 'number',
                    'subparam_c22': 'number',
                    'subparam_c23': 'boolean',
                    'subparam_c24': 'number',
                    'subparam_c25': 'text'
                },
                'param_c3': {
                    'subparam_c31': 'number',
                    'subparam_c32': 'number',
                    'subparam_c33': 'boolean',
                    'subparam_c34': 'number',
                    'subparam_c35': 'text'
                }
            },
            'config_c2': {
                'param_c4': {
                    'subparam_c41': 'number',
                    'subparam_c42': 'number',
                    'subparam_c43': 'boolean',
                    'subparam_c44': 'number',
                    'subparam_c45': 'text'
                },
                'param_c5': {
                    'subparam_c51': 'number',
                    'subparam_c52': 'number',
                    'subparam_c53': 'boolean',
                    'subparam_c54': 'number',
                    'subparam_c55': 'text'
                }
            }
        },
        'sensor_c2': {
            'config_c3': {
                'param_c1': {
                    'subparam_c11': 'number',
                    'subparam_c12': 'number',
                    'subparam_c13': 'boolean',
                    'subparam_c14': 'number',
                    'subparam_c15': 'text'
                },
                'param_c2': {
                    'subparam_c21': 'number',
                    'subparam_c22': 'number',
                    'subparam_c23': 'boolean',
                    'subparam_c24': 'number',
                    'subparam_c25': 'text'
                },
                'param_c3': {
                    'subparam_c31': 'number',
                    'subparam_c32': 'number',
                    'subparam_c33': 'boolean',
                    'subparam_c34': 'number',
                    'subparam_c35': 'text'
                }
            },
            'config_c4': {
                'param_c4': {
                    'subparam_c41': 'number',
                    'subparam_c42': 'number',
                    'subparam_c43': 'boolean',
                    'subparam_c44': 'number',
                    'subparam_c45': 'text'
                },
                'param_c5': {
                    'subparam_c51': 'number',
                    'subparam_c52': 'number',
                    'subparam_c53': 'boolean',
                    'subparam_c54': 'number',
                    'subparam_c55': 'text'
                }
            }
        }
    }
}

export const DUMMY_SENSORS = {
    'sensor_a1': {
        'config_a1': {
            'param_a1': {
                'subparam_a11': 'number',
                'subparam_a12': 'number',
                'subparam_a13': 'boolean',
                'subparam_a14': 'number',
                'subparam_a15': 'text'
            },
            'param_a2': {
                'subparam_a21': 'number',
                'subparam_a22': 'number',
                'subparam_a23': 'boolean',
                'subparam_a24': 'number',
                'subparam_a25': 'text'
            },
            'param_a3': {
                'subparam_a31': 'number',
                'subparam_a32': 'number',
                'subparam_a33': 'boolean',
                'subparam_a34': 'number',
                'subparam_a35': 'text'
            },
            'param_a13': 'text'
        },
        'config_a2': {
            'param_a4': {
                'subparam_a41': 'number',
                'subparam_a42': 'number',
                'subparam_a43': 'boolean',
                'subparam_a44': 'number',
                'subparam_a45': 'text'
            },
            'param_a5': {
                'subparam_a51': 'number',
                'subparam_a52': 'number',
                'subparam_a53': 'boolean',
                'subparam_a54': 'number',
                'subparam_a55': 'text'
            }
        }
    },
    'sensor_a2': {
        'config_a3': {
            'param_a1': {
                'subparam_a11': 'number',
                'subparam_a12': 'number',
                'subparam_a13': 'boolean',
                'subparam_a14': 'number',
                'subparam_a15': 'text'
            },
            'param_a2': {
                'subparam_a21': 'number',
                'subparam_a22': 'number',
                'subparam_a23': 'boolean',
                'subparam_a24': 'number',
                'subparam_a25': 'text'
            },
            'param_a3': {
                'subparam_a31': 'number',
                'subparam_a32': 'number',
                'subparam_a33': 'boolean',
                'subparam_a34': 'number',
                'subparam_a35': 'text'
            }
        },
        'config_a4': {
            'param_a4': {
                'subparam_a41': 'number',
                'subparam_a42': 'number',
                'subparam_a43': 'boolean',
                'subparam_a44': 'number',
                'subparam_a45': 'text'
            },
            'param_a5': {
                'subparam_a51': 'number',
                'subparam_a52': 'number',
                'subparam_a53': 'boolean',
                'subparam_a54': 'number',
                'subparam_a55': 'text'
            }
        }
    },
    'sensor_b1': {
        'config_b1': {
            'param_b1': {
                'subparam_b11': 'number',
                'subparam_b12': 'number',
                'subparam_b13': 'boolean',
                'subparam_b14': 'number',
                'subparam_b15': 'text'
            },
            'param_b2': {
                'subparam_b21': 'number',
                'subparam_b22': 'number',
                'subparam_b23': 'boolean',
                'subparam_b24': 'number',
                'subparam_b25': 'text'
            },
            'param_b3': {
                'subparam_b31': 'number',
                'subparam_b32': 'number',
                'subparam_b33': 'boolean',
                'subparam_b34': 'number',
                'subparam_b35': 'text'
            }
        },
        'config_b2': {
            'param_b4': {
                'subparam_b41': 'number',
                'subparam_b42': 'number',
                'subparam_b43': 'boolean',
                'subparam_b44': 'number',
                'subparam_b45': 'text'
            },
            'param_b5': {
                'subparam_b51': 'number',
                'subparam_b52': 'number',
                'subparam_b53': 'boolean',
                'subparam_b54': 'number',
                'subparam_b55': 'text'
            }
        }
    },
    'sensor_b2': {
        'config_b3': {
            'param_b1': {
                'subparam_b11': 'number',
                'subparam_b12': 'number',
                'subparam_b13': 'boolean',
                'subparam_b14': 'number',
                'subparam_b15': 'text'
            },
            'param_b2': {
                'subparam_b21': 'number',
                'subparam_b22': 'number',
                'subparam_b23': 'boolean',
                'subparam_b24': 'number',
                'subparam_b25': 'text'
            },
            'param_b3': {
                'subparam_b31': 'number',
                'subparam_b32': 'number',
                'subparam_b33': 'boolean',
                'subparam_b34': 'number',
                'subparam_b35': 'text'
            }
        },
        'config_b4': {
            'param_b4': {
                'subparam_b41': 'number',
                'subparam_b42': 'number',
                'subparam_b43': 'boolean',
                'subparam_b44': 'number',
                'subparam_b45': 'text'
            },
            'param_b5': {
                'subparam_b51': 'number',
                'subparam_b52': 'number',
                'subparam_b53': 'boolean',
                'subparam_b54': 'number',
                'subparam_b55': 'text'
            }
        }
    },
    'sensor_c1': {
        'config_c1': {
            'param_c1': {
                'subparam_c11': 'number',
                'subparam_c12': 'number',
                'subparam_c13': 'boolean',
                'subparam_c14': 'number',
                'subparam_c15': 'text'
            },
            'param_c2': {
                'subparam_c21': 'number',
                'subparam_c22': 'number',
                'subparam_c23': 'boolean',
                'subparam_c24': 'number',
                'subparam_c25': 'text'
            },
            'param_c3': {
                'subparam_c31': 'number',
                'subparam_c32': 'number',
                'subparam_c33': 'boolean',
                'subparam_c34': 'number',
                'subparam_c35': 'text'
            }
        },
        'config_c2': {
            'param_c4': {
                'subparam_c41': 'number',
                'subparam_c42': 'number',
                'subparam_c43': 'boolean',
                'subparam_c44': 'number',
                'subparam_c45': 'text'
            },
            'param_c5': {
                'subparam_c51': 'number',
                'subparam_c52': 'number',
                'subparam_c53': 'boolean',
                'subparam_c54': 'number',
                'subparam_c55': 'text'
            }
        }
    },
    'sensor_c2': {
        'config_c3': {
            'param_c1': {
                'subparam_c11': 'number',
                'subparam_c12': 'number',
                'subparam_c13': 'boolean',
                'subparam_c14': 'number',
                'subparam_c15': 'text'
            },
            'param_c2': {
                'subparam_c21': 'number',
                'subparam_c22': 'number',
                'subparam_c23': 'boolean',
                'subparam_c24': 'number',
                'subparam_c25': 'text'
            },
            'param_c3': {
                'subparam_c31': 'number',
                'subparam_c32': 'number',
                'subparam_c33': 'boolean',
                'subparam_c34': 'number',
                'subparam_c35': 'text'
            }
        },
        'config_c4': {
            'param_c4': {
                'subparam_c41': 'number',
                'subparam_c42': 'number',
                'subparam_c43': 'boolean',
                'subparam_c44': 'number',
                'subparam_c45': 'text'
            },
            'param_c5': {
                'subparam_c51': 'number',
                'subparam_c52': 'number',
                'subparam_c53': 'boolean',
                'subparam_c54': 'number',
                'subparam_c55': 'text'
            }
        }
    }
}

export const DUMMY_FILTER = {
    'year': {
        'month': {
            '1': '1 month',
            '2': '2 months'
        },
        'week': {
            '1': '1 week'
        }
    },
    'month': {
        'day': {
            '1': '1 day'
        }
    },
    'week': {
        'day': {
            '1': '1 day'
        },
        'hour': {
            '2': '2 hours',
            '3': '3 hours',
            '4': '4 hours',
            '6': '6 hours',
            '12': '12 hours'
        }
    },
    'day': {
        'hour': {
            '1': '1 hour',
            '2': '2 hours',
            '3': '3 hours',
            '4': '4 hours',
            '6': '6 hours'
        },
        'minute': {
            '15': '15 minutes',
            '30': '30 minutes',
            '60': '60 minutes'
        }
    },
    'hour': {
        'minute': {
            '1': {
                '1': '1 minutes',
                '5': '5 minutes',
                '10': '10 minutes',
                '15': '15 minutes'
            },
            '3': {
                '1': '1 minutes',
                '5': '5 minutes',
                '10': '10 minutes',
                '15': '15 minutes',
                '20': '20 minutes',
                '30': '30 minutes'
            },
            '6': {
                '1': '1 minutes',
                '5': '5 minutes',
                '10': '10 minutes',
                '15': '15 minutes',
                '20': '20 minutes',
                '30': '30 minutes'
            },
            '12': {
                '1': '1 minutes',
                '5': '5 minutes',
                '10': '10 minutes',
                '15': '15 minutes',
                '20': '20 minutes',
                '30': '30 minutes'
            }
        },
    },
    'minute': {
        'seconds': {
            '10': '10 seconds',
            '20': '20 seconds',
            '30': '30 seconds'
        }
    },
}